import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import BusinessSection from '../components/BusinessSection';
import TechSection from '../components/TechSection';
import CasesSection from '../components/CasesSection';
import PhilosophySection from '../components/PhilosophySection';
import VisionSection from '../components/VisionSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

declare global {
  interface Window {
    lucide: any;
  }
}

const HomePage: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Ensure Chinese locale
    if (i18n.language !== 'zh-CN') {
      i18n.changeLanguage('zh-CN');
    }
    // Initialize lucide icons (loaded via CDN)
    if (window.lucide?.createIcons) {
      window.lucide.createIcons();
    }
    const timer = setTimeout(() => {
      if (window.lucide?.createIcons) window.lucide.createIcons();
    }, 200);
    return () => clearTimeout(timer);
  }, [i18n]);

  return (
    <div className="bg-dark-950 text-dark-200 antialiased overflow-x-hidden">
      <Navbar lang="zh" />
      <main>
        <HeroSection />
        <AboutSection />
        <BusinessSection />
        <TechSection />
        <CasesSection lang="zh" />
        <PhilosophySection />
        <VisionSection />
        <ContactSection />
      </main>
      <Footer lang="zh" />
    </div>
  );
};

export default HomePage;
